import { FormSectionHeader, Heading, Loader } from "@/components";
import useDetails from "./useDetails";
import { PencilIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui";

const Details = () => {
  const {
    onBackClick,
    onEditClick,
    comDetails,
    isDetailLoading,
  } = useDetails();

  return (
    <div className="p-4 md:p-6">
      <Heading title="View Details" showBack onBackClick={onBackClick} />
      {isDetailLoading ? (
        <Loader />
      ) : (
        <>
          {Object.keys(comDetails).map((key, index) => {
            const section = comDetails[key as keyof typeof comDetails];
            return (
              <div
                className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]"
                key={`${key}-${index}`}
              >
                <div className="flex items-center justify-between">
                  <FormSectionHeader className="text-[20px]">
                    {section?.title}
                  </FormSectionHeader>
                  <PencilIcon
                    className="h-4 w-4 cursor-pointer"
                    onClick={() => onEditClick(index + 1)}
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                  {section.data?.map((data: any) => (
                    <div className="flex flex-col gap-1" key={`${data.label}`}>
                      <label className="text-[11px] font-[400] text-g-300">
                        {data.label}
                      </label>
                      <div className="flex flex-row items-center">
                        {data.value ? data?.icon : ""}
                        <span
                          className={cn(
                            "text-[14px] font-[500]",
                            data?.icon && "ml-2"
                          )}
                        >
                          {data.value}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
          {/* <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
            <div className="flex items-center justify-between">
              <FormSectionHeader className="text-[20px]">
                Setup GL Master
              </FormSectionHeader>
              <PencilIcon
                className="h-4 w-4 cursor-pointer"
                onClick={() => onEditClick(6)}
              />
            </div>
            <DataTable columns={columns} data={glData?.data || []} />
          </div> */}
          <div className="flex item-center justify-end mt-5">
            <Button type="button" onClick={onBackClick}>
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default Details;
